// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_bq-4";
export var collapsed = "_bq-1";
export var headerBar = "_bq-0";
export var leftHeaderContent = "_bq-3";
export var subjectContainer = "_bq-2";